import { createContext, useReducer } from "react";
import { defualtPageSize } from "../../../logic/common_logic";

export const DataListStore = createContext<IContextProps>(null);

interface IContextProps {
    state: IState;
    dispatch: ({ type }: Dispatch) => void;
}

type Dispatch = { type, payload }

interface IState {
    dataList: any[],
    selectList: any[];
    pageSize: number;
    current: number;
    total: number;
    selectedRowKeys: string[];
}

const initialArgs: IState = {
    dataList: [],
    selectList: [],
    pageSize: defualtPageSize(),
    current: 1,
    total: 0,
    selectedRowKeys: []
}

function reducer(state: IState, { type, payload }: Dispatch) {
    switch (type) {
        case "Set_SelectList":
            return {
                ...state,
                selectList: [...payload]
            }
        case "Clear_SelectedRowKeys":
            return {
                ...state,
                selectedRowKeys: []
            }
        case "Set_SelectedRowKeys":
            return {
                ...state,
                selectedRowKeys: [...payload]
            }
        case "Set_Total":
            return {
                ...state,
                total: payload
            }
        case "Set_DataList":
            return {
                ...state,
                dataList: payload
            }
        case "Set_Current":
            return {
                ...state,
                current: payload
            }
        case "Set_PageSize":
            return {
                ...state,
                pageSize: payload
            }
        default:
            return state;
    }
}

export function DataListStoreProvider(props) {
    const [state, dispatch] = useReducer(reducer, initialArgs);

    const v = { state, dispatch };
    return <DataListStore.Provider value={v}>{props.children}</DataListStore.Provider>
}